 /**
 * @name APP Integration
 * @autor jaime.salazar@u-planner.com
 * @description module datos cargados 
 */

import routing from './tables.route';

//importamos nuestros controladores

import tableCtrl from './tableCtrl';

//importamos nuestros services 

import tablesServices from './tablesServices';


//definimos los controladores y servicios ya importados anteriormente
export default angular.module('app.table', [tablesServices])
  .config(routing)
  .controller('tableCtrl', tableCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/integration-front/tables/index.js